<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[720px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="success"
          />

          <ModalHeader>
            <ModalHeading>Thanks for Approving!</ModalHeading>

            <ModalSubText>
              Thanks for giving me the thumbs-up! Once you click <span class="tw-font-bold">Continue</span>, I’ll go ahead and put everything into action for you.
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>
        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            @click="emit('confirm')"
          >
            Continue
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
